import { UpcomingWebinarsPage } from '@online-webinar/public';
import { RouterType } from '@online-webinar/router/src/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/upcoming'].update({
        staticData: { title: { page: 'Title.Upcoming' } },
        component: UpcomingWebinarsPage
    });
};
